<template>
  <div class="crop-info">
    <div class="row">
      <div class="column">
        <app-sel
          v-model="drainage.cropId"
          filterable
          :label="$ml.get(`Crop Name`)"
          :items="userCrops.filter(x => x.type == 'nutrient solution')"
          key-name="id"
          label-name="name"
          @input="onCropSelect"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
              <template>{{ item.name }}</template>
              <!-- ({{ (item.type == 'soil-grown') ? 'soil grown' : 'hydroponic'  }}) -->
            </app-sel-opt>
          </template>
        </app-sel>
      </div>
      <div class="column">
        <app-sel
          v-model="drainage.varietyId"
          :label="$ml.get(`Type`)"
          :items="varieties"
          key-name="id"
          label-name="name"
          :disabled="!drainage.cropId"
          @input="onVarietySelect"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
              {{ item.name }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>
    </div>
    <div class="row">
      <div class="column">
        <app-sel
          v-model="drainage.growingMethodId"
          :label="$ml.get(`Growing method`)"
          :items="methods"
          key-name="id"
          label-name="name"
          :disabled="!drainage.varietyId"
          @input="onMethodSelect"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
              {{ item.name }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>
      <div class="column">
        <app-sel
          v-model="drainage.stageId"
          :label="$ml.get(`Stage`)"
          :items="stages"
          key-name="id"
          label-name="name"
          :disabled="!drainage.yieldGoalId"
          @input="onStageSelect"
          required
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
                {{ item.name }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>
    </div>


    <!-- <div class="a-row" v-show="false">

      <div class="a-column">
        <app-sel
          v-model="yieldGoalId"
          :label="$ml.get(`Yield Goal, t/ha`)"
          :items="goals"
          key-name="id"
          label-name="goal"
          :disabled="!growingMethodId"
        >
          <template v-slot="{ items }">
            <app-sel-opt v-for="item in items" :value="item" :key="item.key">
                {{ item.goal }}
            </app-sel-opt>
          </template>
        </app-sel>
      </div>

    </div> -->

  </div>
</template>

<script>
import { CropAPI } from '@/api';
import { mapGetters } from 'vuex'

export default {
  props: {

  },
  data() {
    return {
      varieties: [],
      methods: [],
      goals: [],
      stages: [],

      cropId: 0,
      varietyId: 0,
      growingMethodId: 0,
      yieldGoalId: 0,
      stageId: 0,
    }
  },
  methods: {

    primaryLoad() {

      if(this.drainage.cropId) {
        this.getVarieties();
      }
      if(this.drainage.varietyId) {
        this.getMethods();
      }
      if(this.drainage.growingMethodId) {
        this.getYieldGoals();
      }
    },

    onCropSelect() {
      this.varieties = [];
      this.methods = [];
      this.goals = [];

      this.drainage.varietyId = 0;
      this.drainage.growingMethodId = 0;
      this.drainage.yieldGoalId = 0;
      this.drainage.stageId = 0;

      this.getVarieties();
    },

    onVarietySelect() {
      this.methods = [];
      this.goals = [];

      this.drainage.growingMethodId = 0;
      this.drainage.yieldGoalId = 0;
      this.drainage.stageId = 0;

      this.getMethods();
    },

    onMethodSelect() {
      this.goals = [];

      this.drainage.yieldGoalId = 0;
      this.drainage.stageId = 0;

      this.getYieldGoals();
    },

    onStageSelect() {
      this.$store.commit( 'drainage/saveCropInfo', {
        cropId: this.drainage.cropId,
        varietyId: this.drainage.varietyId,
        growingMethodId: this.drainage.growingMethodId,
        yieldGoalId: this.drainage.yieldGoalId,
        stageId: this.drainage.stageId
      });
    },

    getVarieties() {
      return CropAPI.getCropVarieties(this.drainage.cropId).then(res => {
        this.varieties = res.data.data;
      });
    },
    getMethods() {
      return CropAPI.getCropGrowingMethods(this.drainage.varietyId).then(res => {
        this.methods = res.data.data;
      });
    },
    getYieldGoals() {
      return CropAPI.getYieldGoals(this.drainage.growingMethodId).then(res => {
        this.goals = res.data.data;
        this.drainage.yieldGoalId = this.goals[0].id;
        this.getCropStages();
      });
    },
    getCropStages() {
      return CropAPI.getInfoByGoal(this.drainage.yieldGoalId).then(res => {
        this.stages = res.data.data.stages;
          // this.stageId = this.stage[0].id;

      });
    },
  },

  created() {
    if(this.drainage.cropId)
      this.primaryLoad()
  },

  computed: {
    ...mapGetters({
      userCrops : 'user-crops/data',
      crop: 'drainage/crop',
      drainage: 'drainage/data'
    })
  },

  watch: {
    'drainage.cropId' : {
      handler: function(val) {
        this.primaryLoad()
      }
    },
    '$route.params.id': {
      handler: function(id) {
        if(this.drainage.cropId)
          this.primaryLoad()
      }
    }
  }


  // beforeUpdate() {
  //   this.primaryLoad();

  // },
}
</script>

<style lang="scss" scoped>

.crop-info {
  padding: 20px 0;
  .row {
    width: 100%;
    display: flex;
    .column {
      width: 50%;
      &:first-child {
        margin-right: 30px;
      }
    }
    &:last-child {
      margin-top: 30px;
    }
  }
}

</style>
